// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.jmreport-report-page[data-v-39c528aa] {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: #fff;\n}\n.jmreport-report-page__iframe[data-v-39c528aa] {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  background: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
